var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueRegularIsometric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.16 390.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#207d8c;}.cls-2{fill:#1f2a58;}.cls-3{fill:#3953a4;}.cls-4{fill:#131724;}.cls-5{fill:#11131a;}.cls-6{fill:#141b3e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519.39,229.93C517.13,227.58,318.89,21.48,311,13.15c-8.55-8.95-19.88-4.84-20.09-4.76.1,0,.66-.27-9.53,2.65-10.79,3.08-14.29-.8-14.29-.8S263.09,5,249.41,9C233.58,13.53,7.86,70.89,7.86,70.89S.77,72.71.69,80,0,124.73,0,124.73,195.25,376.11,202.91,386.07c6.27,8.2,22,2.49,22,2.49s284.08-103,290.7-105.41c5.81-2.49,5.39-7.66,5.39-7.66l.13-37.91S521.36,232,519.39,229.93ZM421.7,172.26l-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L423.54,165C426.18,167.78,425.36,171.06,421.7,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M483,185.58C481.15,183.62,316,11.86,309.33,4.93c-7.11-7.46-16.56-4-16.73-4,.08,0,.55-.23-8,2.2-9,2.58-11.91-.66-11.91-.66s-3.29-4.36-14.69-1.07C244.86,5.24,56.76,53,56.76,53s-5.91,1.52-6,7.57-.58,37.3-.58,37.3S212.92,307.39,219.3,315.69c5.23,6.83,18.36,2.08,18.36,2.08S474.4,232,479.91,229.92c4.84-2.07,4.5-6.38,4.5-6.38l.1-31.59S484.68,187.34,483,185.58ZM421.7,172.26l-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L423.54,165C426.18,167.78,425.36,171.06,421.7,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.42,182.73S316,11.75,309.33,4.81c-7.11-7.46-16.56-4-16.73-4,.08,0,.55-.22-7.94,2.21-9,2.57-11.92-.66-11.92-.66S269.45-2,258.05,1.31C244.86,5.12,56.76,52.93,56.76,52.93s-8.71,3-3.6,9.42L101.76,126S209.27,261.24,217.31,271.29s23.12,3.88,23.12,3.88,227.06-77.39,237.78-81S480.42,182.73,480.42,182.73ZM421.7,172.26l-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L423.54,165C426.18,167.78,425.36,171.06,421.7,172.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.12 281.15 242.12 308.67 474.93 224.48 474.93 201.17 242.12 281.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "474.93 201.17 458.59 206.84 474.93 224.48 474.93 201.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.46,128.13l-7.76,1.57C122,151.42,210.06,262.23,217.31,271.29A15.61,15.61,0,0,0,229.06,277Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M480.42,182.73S409.89,109.41,359.35,56.84l-4.08,1.74L482.68,191.4C485.71,187.58,480.42,182.73,480.42,182.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117,58.53c-8.47,2.19-26.71,8.67-16.64,21.56s24.94,13.26,42.42,8.43,132.73-36.46,143.9-39.6,25.7-9.77,12.89-21.8-30.41-8.71-44.76-4.92S125.48,56.33,117,58.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M317.41,13.22l-2-2-25.08,6.74a31.13,31.13,0,0,1,3.67,1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.79,70.72,65.1,78.07,67,80.58l25.8-6.91A9.15,9.15,0,0,1,92.79,70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M321.62,17.6l-1.95-2-22.27,6a29,29,0,0,1,2.45,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68.61,82.62l1.93,2.5,24.23-6.47A17.48,17.48,0,0,1,93.48,76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M304,27.77l21.75-5.92-1.94-2-21.6,5.86c.32.33.63.67.94,1S303.68,27.42,304,27.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.59,81.29,72.52,87.8l1.94,2.49L98.6,83.7c-.48-.53-.95-1.08-1.42-1.65C97,81.79,96.78,81.54,96.59,81.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.24,92.56l2,2.49,25.17-6.89c-.88-.69-1.74-1.44-2.6-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M329.79,26.1l-1.94-2-22.24,6.05a15.89,15.89,0,0,1,1.18,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.44,96.8l2,2.48,27.69-7.54a30.71,30.71,0,0,1-3.51-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M307.59,37.37l26.16-7.16-1.93-2-24.31,6.61A8.81,8.81,0,0,1,307.59,37.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M429.65,165.28,330,59.9a16.45,16.45,0,0,0-14.85-4.11l-183.54,51.5c-4.76,1.34-6.12,5.59-3,9.44L223,233.88a14,14,0,0,0,14.19,4.17l190.15-63.39C432,173.1,433.05,168.87,429.65,165.28Zm-7.95,7-184,60.7a10.86,10.86,0,0,1-11-3.26l-91-113.52c-2.41-3-1.34-6.31,2.36-7.35l177-49.59a12.76,12.76,0,0,1,11.55,3.2L423.54,165C426.18,167.78,425.36,171.06,421.7,172.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M330.47,217.59c-3.12-1.08-3.11-2.79,0-3.82l22.32-7.3c3.13-1,5.27.8,4.74,4.06L356,220.11a4.9,4.9,0,0,1-6.63,4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRegularIsometric);
export default __webpack_public_path__ + "static/media/blue-regular-isometric.871dc7b7d76a810ee0725ac630ea8d1d.svg";
export { ForwardRef as ReactComponent };